/** 检查权限的方法 */
import store from '@/store';
import _ from 'lodash'
const hasPerm = (permArray) => {
    return _.difference(store.getters.perms,permArray).length !== store.getters.perms.length
};

export default {
  bind: function (el, binding) {
    if (el && binding.value) {
      if (!hasPerm(binding.value)) {
        (el.parentNode && el.parentNode.removeChild(el)) || (el.style.display = 'none');
      }
    }
  },
};
